import { render, staticRenderFns } from "./UploadPeriods.vue?vue&type=template&id=e9d0437e&"
import script from "./UploadPeriods.vue?vue&type=script&lang=js&"
export * from "./UploadPeriods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QMenu,QList,QItem,QItemSection,QCardSection,QSelect,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn,QMenu,QList,QItem,QItemSection,QCardSection,QSelect})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
